<template>
  <div>
    <div v-if="bikeNotFound" class="cell">
      <pdl-callout kind="warning">
        <template #content>
          <span v-html="bikeNotFound" />
        </template>
      </pdl-callout>
    </div>
    <div class="cell">
      <header class="section-header section-header--lg mt-3">
        <h1 qaid="find-bike-registration-title" class="heading">{{ bp('registerCustomersBike') }}</h1>
      </header>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell large-6">
        <p class="mb-3" qaid="find-bike-registration-description">{{ bp('registrationDescription') }}</p>
        <fieldset class="max-w-sm">
          <div class="form-group" :class="errorMsg ? 'has-error' : ''">
            <label for="serial-input" class="form-label">{{ bp('serialNumber') }}</label>
            <input
              id="serial-input"
              v-model="serialNumber"
              type="text"
              name="serial-input"
              class="form-control"
              qaid="find-bike-serial-number"
              :maxlength="30"
              @keyup.enter="submitSerialNumber"
            />
            <span v-if="errorMsg" class="form-feedback is-invalid" qaid="find-bike-error-message" v-html="errorMsg" />
          </div>
        </fieldset>
        <div class="buttons">
          <trek-button primary qaid="find-bike-button" :disabled="!serialNumber" @click="submitSerialNumber">
            <span v-html="bp('findBike')" />
          </trek-button>
        </div>
        <div class="mb-2">
          <a
            class="underline hover:no-underline"
            :href="contactUsUrl"
            qaid="find-bike-contact-us"
            v-html="bp('requestSupport')"
          />
        </div>
      </div>
      <div class="cell large-6">
        <div class="px-2 py-3 bg-gray-05">
          <img qaid="find-bike-serial-number-location" :src="serialNumberLocationImage" />
          <p class="mt-2">{{ bp('serialNumberLocation') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import {PdlCallout} from '@pedal/pdl-callout';
import {mapState} from 'vuex';

export default {
  components: {TrekButton, PdlCallout},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    errorMsg: {
      type: String,
      default: '',
    },
    bikeNotFound: {
      type: String,
      default: '',
    },
    contextPath: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      serialNumber: '',
      serialNumberLocationImage:
        'https://trek.scene7.com/is/image/TrekBicycleProducts/BikeRegistration_sn_location?$responsive-pjpg$&wid=785&hei=400',
    };
  },
  computed: {
    contactUsUrl() {
      return `${this.contextPath}/${this.b2b ? 'contact-us' : 'contactUs'}`;
    },
    ...mapState('backend', ['b2b']),
  },

  methods: {
    submitSerialNumber() {
      if (this.serialNumber && this.serialNumber.length > 0) {
        window.location.href = `${this.contextPath}/${this.b2b ? 'bike-registration' : 'productRegistration'}/serial/${
          this.serialNumber
        }`;
      }
    },
  },
};
</script>
